import { Heading, Paragraph, Stack, Text } from '@customerio/pluma-components/react';

type RequestSentStepProps = {
  accountName: string;
};

/**
 * Confirmation after the join request went out. Deliberately final: the page
 * offers no request status — a declined request is indistinguishable from a
 * pending one (the admins decide silently).
 */
export function RequestSentStep({ accountName }: RequestSentStepProps) {
  return (
    <Stack gap="200" data-test-join-request-sent>
      <Heading level="1" size="m">
        Request sent
      </Heading>
      <Paragraph color="subtle">
        We've notified the admins of <Text weight="semibold">{accountName}</Text>. Once an admin approves your request,
        you'll receive an email to set your password and get started.
      </Paragraph>
      <Paragraph color="subtle">You can close this page.</Paragraph>
    </Stack>
  );
}
